import { CSSProperties } from 'react'

export const s = {
  wrapper: {
    position: 'relative',
  } as CSSProperties,
  card: {
    padding: 0,
  } as CSSProperties,
  collapsed: {
    padding: 26,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  } as CSSProperties,
}
